import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const UserTermsAndConditionsAcceptanceSchema = z.object({
  userTermsAndConditionsAcceptanceId: PrimaryKeySchema,
  userId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type UserTermsAndConditionsAcceptance = z.infer<
  typeof UserTermsAndConditionsAcceptanceSchema
>;

export const UserTermsAndConditionsAcceptancesSchema = z.array(
  UserTermsAndConditionsAcceptanceSchema,
);

export type UserTermsAndConditionsAcceptances = z.infer<
  typeof UserTermsAndConditionsAcceptancesSchema
>;

export const UserTermsAndConditionsAcceptanceFiltersSchema = z.object({
  userIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type UserTermsAndConditionsAcceptanceFilters = z.infer<
  typeof UserTermsAndConditionsAcceptanceFiltersSchema
>;
